import { Service } from "../../../../types";
import { EnvironmentAnalytics } from "./EnvironmentAnalytics";
import { ServicesList } from "./ServicesList";

interface ProjectOverviewTabProps {
  services: Service[];
  servicesLoading?: boolean;
  deploymentsLoading?: boolean;
  selectedEnvironment: any;
  environmentAnalytics: {
    servicesCount: number;
    runningServices: number;
    deploymentsCount: number;
    failedDeployments: number;
    failedDeploymentLink?: string;
  };
  onAddService: () => void;
  onRefreshServices: () => void;
  onDeploymentStarted: () => void;
}

export function ProjectOverviewTab({
  services,
  servicesLoading,
  deploymentsLoading,
  selectedEnvironment,
  environmentAnalytics,
  onAddService,
  onRefreshServices,
  onDeploymentStarted,
}: ProjectOverviewTabProps) {
  return (
    <div className="space-y-6">
      {/* Environment Analytics */}
      {selectedEnvironment && (
        <EnvironmentAnalytics {...environmentAnalytics} loading={deploymentsLoading} />
      )}

      {/* Services List */}
      <ServicesList
        services={services}
        loading={servicesLoading}
        selectedEnvironment={selectedEnvironment}
        onAddService={onAddService}
        onRefresh={onRefreshServices}
        onDeploymentStarted={onDeploymentStarted}
      />
    </div>
  );
}
